import type { PortalThemeName } from './default';

/** Semantic graph colors kept separate from the general MUI palette. */
export type FlowThemeTokens = {
	canvas: string;
	nodeSurface: string;
	grid: string;
	agent: string;
	trigger: string;
	exit: string;
	start: string;
	block: string;
	note: string;
	error: string;
};

export const flowThemeTokens: Record<PortalThemeName, FlowThemeTokens> = {
	'dark-main': {
		canvas: '#1a1a1a',
		nodeSurface: '#292929',
		grid: '#626262',
		agent: '#7c5a4a',
		trigger: '#4a7c59',
		exit: '#7c4a6e',
		start: '#4a6e7c',
		block: '#c89650',
		note: '#dcc83c',
		error: '#8b3535',
	},
	'dark-blue': {
		canvas: '#071526',
		nodeSurface: '#102640',
		grid: '#57708F',
		agent: '#168BFF',
		trigger: '#43D17D',
		exit: '#C084FC',
		start: '#28D7FF',
		block: '#F2B84B',
		note: '#F4D35E',
		error: '#FF6B6B',
	},
	'white-blue': {
		// The graph canvas intentionally has more contrast than normal workspace
		// surfaces so white-blue nodes, edges, and the minimap are easy to scan.
		canvas: '#DCE6F1',
		nodeSurface: '#F3F5F6',
		grid: '#A9BBD0',
		agent: '#168BFF',
		trigger: '#159B58',
		exit: '#8B5CF6',
		start: '#0EA5E9',
		block: '#C77A12',
		note: '#B7791F',
		error: '#D64545',
	},
	'light-warm': {
		// A warmer graph plane keeps the canvas distinct from ivory workspace surfaces.
		canvas: '#EFE5D6',
		nodeSurface: '#F6F2EC',
		grid: '#D6C3AE',
		agent: '#4A7FA3',
		trigger: '#5D9B72',
		exit: '#A76F90',
		start: '#4A9FB8',
		block: '#BF7C3D',
		note: '#B8953D',
		error: '#C75D58',
	},
	'randol-warm': {
		// Warm canvas with stronger blue accents for higher edge contrast.
		canvas: '#EFE5D6',
		nodeSurface: '#F6F2EC',
		grid: '#D6C3AE',
		agent: '#2563EB',
		trigger: '#168A4A',
		exit: '#A76F90',
		start: '#2B8AD6',
		block: '#D97706',
		note: '#B8953D',
		error: '#C75D58',
	},
	'randol-branded': {
		// Palette aligned to the updated Randol brand guide.
		canvas: '#F4E6D6',
		nodeSurface: '#FBF7F2',
		grid: '#BCEDEE',
		agent: '#00B8B0',
		trigger: '#006D6B',
		exit: '#F25B3A',
		start: '#006D6B',
		block: '#F7A38B',
		note: '#172A2A',
		error: '#F25B3A',
	},
};
